import { useState } from "react";
import LanguageToggler from "./language-toggler";

interface HeaderProps {
  logo?: string;
  icon?: string;
  businessName?: string;
  textColor: string;
}

export default function Header({
  logo,
  icon,
  businessName,
  textColor,
}: HeaderProps) {
  const [imageLoading, setImageLoading] = useState(true);
  const imageSrc = icon || logo;

  return (
    <div className="flex items-center justify-between p-6">
      <div className="flex items-center gap-3">
        {imageSrc && (
          <>
            {imageLoading && (
              <div className="h-10 w-10 animate-pulse rounded-lg bg-gray-300" />
            )}
            <img
              src={imageSrc}
              alt={businessName || ""}
              className={`h-10 w-10 rounded-lg object-cover ${imageLoading ? "hidden" : ""}`}
              onLoad={() => setImageLoading(false)}
            />
          </>
        )}
        {businessName && (
          <span className="text-lg font-semibold" style={{ color: textColor }}>
            {businessName}
          </span>
        )}
      </div>
      <LanguageToggler textColor={textColor} />
    </div>
  );
}
